// extracted by mini-css-extract-plugin
export default {"AddItem":"AddItem_AddItem__tkx-9","Text":"AddItem_Text__5RRC7","Img":"AddItem_Img__IpwXF","AddIcon":"AddItem_AddIcon__xnPmT","Content":"AddItem_Content__J+vT3"};